import { jsx as l, Fragment as Et, jsxs as nt } from "react/jsx-runtime";
import { OverlayViewF as te } from "@react-google-maps/api";
import { useState as S, useRef as y, useEffect as Z, useCallback as Y, useMemo as ot } from "react";
import { ChangeCircle as ee } from "@mui/icons-material";
import { Box as v } from "@mui/material";
import { overlayWrapperStyles as m } from "./styles.js";
const ne = 100, oe = 17, ge = ({
  id: St,
  map: r,
  floorPlanUrl: F,
  rfPlanUrl: rt,
  sinrPlanUrl: st,
  dominantCellPlanUrl: at,
  customPlanUrl: ct,
  floorPlanOpacity: Tt,
  rfPlanOpacity: Wt,
  sinrPlanOpacity: Bt = 0,
  dominantCellPlanOpacity: Ht = 0,
  customPlanOpacity: Nt = 0,
  rotation: K,
  setRotation: it,
  skewX: I,
  skewY: b,
  onPositionChange: $,
  onBoundsChange: x,
  isActive: z,
  inactiveOpacity: jt,
  bounds: O,
  zIndex: Q
}) => {
  const [s, H] = S(O), [T, lt] = S(!1), [N, gt] = S(!1), [zt, ut] = S(null), [A, Ct] = S(null), [V, Zt] = S(null), [dt, ft] = S(!1), [J, mt] = S(K), [C, Yt] = S(!1), Lt = y(!1), k = y(1), wt = y(!1), U = y(null), X = y(null), Ot = y(null), Xt = y(null), q = y(O), tt = y(!1), et = y(!1), W = y(null);
  Z(() => (W.current || (W.current = document.createElement("style"), document.head.appendChild(W.current)), N ? W.current.textContent = `
        body, html, #map, .gm-style, .gm-style > div, .gm-style > div > div, .gm-style > div > div > div {
          cursor: crosshair !important;
        }
      ` : T ? W.current.textContent = `
        body, html, #map, .gm-style, .gm-style > div, .gm-style > div > div, .gm-style > div > div > div {
          cursor: move !important;
        }
      ` : W.current.textContent = "", () => {
    W.current && (W.current.textContent = "");
  }), [N, T]);
  const G = Y((t) => {
    if (t)
      try {
        return t instanceof google.maps.LatLngBounds ? t : "north" in t && "south" in t ? new google.maps.LatLngBounds(new google.maps.LatLng(t.south, t.west), new google.maps.LatLng(t.north, t.east)) : "northeast" in t && "southwest" in t ? new google.maps.LatLngBounds(new google.maps.LatLng(t.southwest.lat, t.southwest.lng), new google.maps.LatLng(t.northeast.lat, t.northeast.lng)) : void 0;
      } catch (i) {
        console.error("Error ensuring valid bounds:", i);
        return;
      }
  }, []);
  Z(() => {
    mt(K);
  }, [K]), Z(() => {
    if (O && !Lt.current) {
      const t = G(O);
      t && (H(t), q.current = t, Lt.current = !0);
    }
  }, [O, G]), Z(() => {
    (T || N) && (tt.current = !0);
  }, [T, N]), Z(() => {
    if (!r) return;
    const t = () => {
      const e = r.getZoom();
      Yt(e !== void 0 && e < oe);
    };
    t();
    const i = r.addListener("zoom_changed", t);
    return () => {
      google.maps.event.removeListener(i);
    };
  }, [r]);
  const Ft = Y((t) => {
    const i = t.target, e = i.naturalWidth, L = i.naturalHeight;
    Ct({
      width: e,
      height: L
    });
    const h = e / L;
    if (k.current = h, wt.current = !0, s && r)
      try {
        const n = r.getProjection();
        if (n) {
          const c = s.getSouthWest(), a = s.getNorthEast(), p = s.getCenter();
          if (c && a && p) {
            const g = r.getZoom() || 0, w = Math.pow(2, g), P = n.fromLatLngToPoint(c), d = n.fromLatLngToPoint(a);
            if (P && d) {
              const o = Math.abs(d.x - P.x) * w, R = o / h, u = n.fromLatLngToPoint(p);
              if (u) {
                const f = o / 2 / w, D = R / 2 / w, _ = new google.maps.Point(u.x + f, u.y - D), B = new google.maps.Point(u.x - f, u.y + D), j = n.fromPointToLatLng(_), M = n.fromPointToLatLng(B);
                if (j && M) {
                  const E = new google.maps.LatLngBounds(M, j);
                  H(E), x(E);
                }
              }
            }
          }
        }
      } catch (n) {
        console.error("Error adjusting bounds:", n);
      }
  }, [r, s, x]), It = Y((t) => {
    const i = t.target, e = i.naturalWidth, L = i.naturalHeight;
    if (Zt({
      width: e,
      height: L
    }), !F) {
      const h = e / L;
      if (k.current = h, wt.current = !0, s && r)
        try {
          const n = r.getProjection();
          if (n) {
            const c = s.getSouthWest(), a = s.getNorthEast(), p = s.getCenter();
            if (c && a && p) {
              const g = r.getZoom() || 0, w = Math.pow(2, g), P = n.fromLatLngToPoint(c), d = n.fromLatLngToPoint(a);
              if (P && d) {
                const o = Math.abs(d.x - P.x) * w, R = o / h, u = n.fromLatLngToPoint(p);
                if (u) {
                  const f = o / 2 / w, D = R / 2 / w, _ = new google.maps.Point(u.x + f, u.y - D), B = new google.maps.Point(u.x - f, u.y + D), j = n.fromPointToLatLng(_), M = n.fromPointToLatLng(B);
                  if (j && M) {
                    const E = new google.maps.LatLngBounds(M, j);
                    H(E), x(E);
                  }
                }
              }
            }
          }
        } catch (n) {
          console.error("Error adjusting bounds:", n);
        }
    }
  }, [r, s, x, F]), bt = Y((t) => {
    if (t.preventDefault(), t.stopPropagation(), !r || !s) return;
    lt(!0);
    const i = {
      x: t.clientX,
      y: t.clientY
    }, e = s.toJSON(), L = {
      value: new google.maps.LatLngBounds(new google.maps.LatLng(e.south, e.west), new google.maps.LatLng(e.north, e.east))
    }, h = (c) => {
      if (!r) return;
      c.preventDefault(), c.stopPropagation();
      const a = c.clientX - i.x, p = c.clientY - i.y, g = r.getProjection();
      if (!g) return;
      const w = new google.maps.LatLng(e.north, e.east), P = new google.maps.LatLng(e.south, e.west), d = g.fromLatLngToPoint(w), o = g.fromLatLngToPoint(P);
      if (!d || !o) return;
      const R = Math.pow(2, r.getZoom() || 0), u = a / R, f = p / R;
      d.x += u, d.y += f, o.x += u, o.y += f;
      const D = g.fromPointToLatLng(d), _ = g.fromPointToLatLng(o);
      if (!D || !_) return;
      const B = new google.maps.LatLngBounds(_, D);
      L.value = B, H(B);
    }, n = () => {
      window.removeEventListener("mousemove", h), window.removeEventListener("mouseup", n);
      const c = L.value;
      if (c) {
        H(c), q.current = c;
        const a = c.getCenter();
        a && $(a.lat(), a.lng()), et.current = !0, tt.current = !0, x(c);
      }
      lt(!1);
    };
    window.addEventListener("mousemove", h), window.addEventListener("mouseup", n);
  }, [r, s, $, x]);
  Z(() => {
    !T && et.current && s && (et.current = !1, setTimeout(() => {
      x(s);
    }, 0));
  }, [T, s, x]);
  const $t = Y((t) => {
    if (t.preventDefault(), t.stopPropagation(), !X.current || !s) return;
    const i = X.current.getBoundingClientRect(), e = i.left + i.width / 2, L = i.top + i.height / 2, h = Math.atan2(t.clientY - L, t.clientX - e), n = J, c = {
      value: n
    };
    ft(!0);
    const a = (g) => {
      g.preventDefault(), g.stopPropagation();
      const d = (Math.atan2(g.clientY - L, g.clientX - e) - h) * (180 / Math.PI), o = n + d;
      c.value = o, mt(o), U.current && (U.current.style.transform = `rotate(${o}deg) skew(${I}deg, ${b}deg)`);
    }, p = () => {
      window.removeEventListener("mousemove", a), window.removeEventListener("mouseup", p), it(c.value), ft(!1);
    };
    window.addEventListener("mousemove", a), window.addEventListener("mouseup", p);
  }, [s, J, it, I, b]), At = Y((t, i) => {
    if (t.preventDefault(), t.stopPropagation(), !r || !s || !X.current) return;
    const e = X.current.getBoundingClientRect(), L = t.clientX, h = t.clientY, n = e.left + e.width / 2, c = e.top + e.height / 2, a = s.toJSON(), p = k.current || (A ? A.width / A.height : V ? V.width / V.height : 1), g = Math.sqrt(Math.pow(L - n, 2) + Math.pow(h - c, 2));
    gt(!0), ut(i);
    const w = {
      value: new google.maps.LatLngBounds(new google.maps.LatLng(a.south, a.west), new google.maps.LatLng(a.north, a.east))
    }, P = (o) => {
      if (o.preventDefault(), o.stopPropagation(), !r) return;
      const u = Math.sqrt(Math.pow(o.clientX - n, 2) + Math.pow(o.clientY - c, 2)) / g, f = r.getProjection();
      if (!f) return;
      const D = r.getZoom() || 0, _ = Math.pow(2, D), B = new google.maps.LatLng(a.north, a.east), j = new google.maps.LatLng(a.south, a.west), M = f.fromLatLngToPoint(B), E = f.fromLatLngToPoint(j);
      if (!M || !E) return;
      const vt = (M.x + E.x) / 2, Pt = (M.y + E.y) / 2, Kt = Math.abs(M.x - E.x) * _, Rt = Math.max(Kt * u, ne), Qt = Rt / p, yt = Rt / (2 * _), xt = Qt / (2 * _), kt = new google.maps.Point(vt + yt, Pt - xt), Ut = new google.maps.Point(vt - yt, Pt + xt), Dt = f.fromPointToLatLng(Ut), _t = f.fromPointToLatLng(kt);
      if (!Dt || !_t) return;
      const Mt = new google.maps.LatLngBounds(Dt, _t);
      w.value = Mt, H(Mt);
    }, d = () => {
      window.removeEventListener("mousemove", P), window.removeEventListener("mouseup", d);
      const o = w.value;
      if (o) {
        H(o), q.current = o;
        const R = o.getCenter();
        R && $(R.lat(), R.lng()), tt.current = !0, x(o);
      }
      gt(!1), ut(null);
    };
    window.addEventListener("mousemove", P), window.addEventListener("mouseup", d);
  }, [r, s, A, V, x, $]), Vt = ({
    corner: t
  }) => {
    const i = zt === t;
    return /* @__PURE__ */ l(v, { sx: m.resizeHandle(i, C, t), onMouseDown: (e) => {
      e.preventDefault(), e.stopPropagation(), At(e, t);
    } });
  }, Jt = () => /* @__PURE__ */ l(v, { sx: m.rotateHandle(C), onMouseDown: (t) => {
    t.preventDefault(), t.stopPropagation(), $t(t);
  }, children: /* @__PURE__ */ l(
    ee,
    {
      sx: {
        ...m.rotateHandleIcon,
        fontSize: "20px"
      }
    }
  ) }), qt = () => /* @__PURE__ */ l(v, { sx: m.zoomIndicator(C && z), children: "Zoom in to edit" }), Gt = ot(() => `rotate(${J}deg) skew(${I}deg, ${b}deg)`, [J, I, b]), ht = ot(() => T || N || dt, [T, N, dt]), pt = ot(() => s || q.current, [s]);
  return /* @__PURE__ */ l(Et, { children: r && G(pt) && /* @__PURE__ */ l(te, { mapPaneName: z ? "overlayMouseTarget" : "overlayLayer", bounds: G(pt), zIndex: Q || (z ? 1e3 : 1), children: /* @__PURE__ */ l(v, { ref: X, sx: m.imageContainer(z, jt, ht, Q), children: /* @__PURE__ */ l(v, { ref: U, "data-overlay-id": St, sx: m.overlayContainer(Gt, ht, Q), children: /* @__PURE__ */ nt("div", { style: m.contentWrapper, children: [
    /* @__PURE__ */ nt(v, { sx: m.imageWrapper(z), children: [
      F && /* @__PURE__ */ l(v, { component: "img", ref: Ot, src: F, alt: "floor plan overlay", sx: m.planImage(Tt), draggable: !1, onLoad: Ft }),
      rt && /* @__PURE__ */ l(v, { component: "img", ref: Xt, src: rt, alt: "RF plan overlay", sx: m.planImage(Wt), draggable: !1, onLoad: It }),
      st && /* @__PURE__ */ l(v, { component: "img", src: st, alt: "SINR plan overlay", sx: m.planImage(Bt), draggable: !1 }),
      at && /* @__PURE__ */ l(v, { component: "img", src: at, alt: "Dominant cell plan overlay", sx: m.planImage(Ht), draggable: !1 }),
      ct && /* @__PURE__ */ l(v, { component: "img", src: ct, alt: "Custom plan overlay", sx: m.planImage(Nt), draggable: !1 })
    ] }),
    z && /* @__PURE__ */ nt(Et, { children: [
      !C && /* @__PURE__ */ l(Jt, {}),
      ["topLeft", "topRight", "bottomLeft", "bottomRight"].map((t) => /* @__PURE__ */ l(Vt, { corner: t }, t)),
      /* @__PURE__ */ l(qt, {}),
      /* @__PURE__ */ l(v, { sx: m.dragArea(C, N), onMouseDown: C ? void 0 : bt })
    ] })
  ] }) }) }) }) });
};
export {
  ge as OverlayWrapper
};
